/**
 * A function that can get the valid rate for any number
 * @param rate Any rate value
 * @returns Validated rate
 */
export const getValidRate = (rate: number = 0): number => {
  return rate >= 0 ? rate : 0;
};
